import { render, staticRenderFns } from "./Fabricando.vue?vue&type=template&id=38a64129&scoped=true&"
import script from "./Fabricando.vue?vue&type=script&lang=js&"
export * from "./Fabricando.vue?vue&type=script&lang=js&"
import style0 from "./Fabricando.vue?vue&type=style&index=0&id=38a64129&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a64129",
  null
  
)

export default component.exports